import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setPrefs } from '../redux/prefs/prefsSlice';
import { setUserFromToken } from '../redux/user/userSlice';
import { updateAttributorFromBackend } from '../utils/activityTracking';
import { jwtDecode } from 'jwt-decode';
import { identifyUser, clearIdentity, trackEvent } from '../utils/analytics';

const useAfterLogin = () => {
  const dispatch = useDispatch();

  const trackLogin = useCallback((method) => {
    trackEvent('Login', {
      event_category: 'User',
      event_label: method
    });
  }, []);

  const afterLogin = useCallback((data, method = 'Unknown') => {
    const { token, prefs, lastCampaign } = data || {};

    dispatch(setUserFromToken(token || null));

    // Note: We don't manually dispatch setPrefs here anymore
    // The prefsSaga handleUserLogin will automatically load preferences from backend
    // However, if Firebase response includes prefs, we still apply them for immediate feedback
    if (prefs) {
      dispatch(setPrefs(prefs));
    }

    if (lastCampaign?.name) {
      updateAttributorFromBackend(lastCampaign);
    }

    // Only track if there's data (i.e., login, not logout)
    if (data) {
      trackLogin(method);
      // Identify user in GA (use internal user id from token if possible)
      try {
        let userId = null;
        if (token) {
          try {
            const decoded = jwtDecode(token);
            userId = decoded.id || decoded.userId || decoded.sub || decoded.uid || null;
          } catch (e) {
            // ignore
          }
        }
        // Fallback: some backends return user object directly
        if (!userId && data.user && data.user.id) {
          userId = data.user.id;
        }
        if (userId) {
          identifyUser(userId);
        }
      } catch (e) {
        // ignore analytics failures
      }
    } else {
      // logout flow: clear GA identity
      try {
        clearIdentity();
      } catch (e) {
        // ignore
      }
    }
  }, [dispatch, trackLogin]);

  return afterLogin;
};

export default useAfterLogin;